import { useAdminAuth } from './AdminAuthProvider'

interface AdminSidebarProps {
  currentPage: string
  onNavigate: (page: string) => void
}

export function AdminSidebar({ currentPage, onNavigate }: AdminSidebarProps) {
  const auth = useAdminAuth()

  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar-header">
        <span className="admin-logo">Admin</span>
      </div>
      <nav className="admin-sidebar-nav">
        <button
          className={`admin-nav-item ${currentPage === 'users' ? 'active' : ''}`}
          onClick={() => onNavigate('users')}
        >
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
          Users
        </button>

        <div className="admin-nav-section">
          <span className="admin-nav-section-title">Blog</span>
        </div>

        <button
          className={`admin-nav-item ${currentPage === 'blog' ? 'active' : ''}`}
          onClick={() => onNavigate('blog')}
        >
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
          Blog Management
        </button>

        <button
          className={`admin-nav-item ${currentPage === 'blog-covers' ? 'active' : ''}`}
          onClick={() => onNavigate('blog-covers')}
        >
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21 15 16 10 5 21"/>
          </svg>
          Blog Cover Library
        </button>

        <button
          className={`admin-nav-item ${currentPage === 'blog-upload' ? 'active' : ''}`}
          onClick={() => onNavigate('blog-upload')}
        >
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="17 8 12 3 7 8"/>
            <line x1="12" y1="3" x2="12" y2="15"/>
          </svg>
          Blog Upload
        </button>

        <div className="admin-nav-section">
          <span className="admin-nav-section-title">Skills</span>
        </div>

        <button
          className={`admin-nav-item ${currentPage === 'skills' ? 'active' : ''}`}
          onClick={() => onNavigate('skills')}
        >
          <svg className="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
          Skills
        </button>
      </nav>
      <div className="admin-sidebar-footer">
        <button className="admin-logout-btn" onClick={auth.disconnect}>
          Logout
        </button>
      </div>
    </aside>
  )
}
